import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit,Output } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb'; 
import { forkJoin } from 'rxjs';
import { FunctionService } from 'vhobjects-service/src/services';
@Component({
  selector: 'atw-sort-product-config',
  templateUrl: './sort-product-config.component.html',
  styleUrls: ['./sort-product-config.component.scss']
})
export class AtwSortProductConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;
  @Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  // @Input() data_tool: any;
  // @Input() type_config: string;
  @Input() visible_config_tool = false;
  @Input() device: any;
  @Output() save = new EventEmitter();
  @Output() closeConfigEvent = new EventEmitter();
  @Output() closeConfigTool = new EventEmitter();
  public dataAfterChange: any = {};

  // xử lý chỉ mở được 1 menu 1 lần
  public openMap: any = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
  };
  public openMapSub = {
    submenu1: true,
    submenu2: false,
    submenu3: false,
    submenu4: false,
    submenu5: false,
    submenu6: false,
    submenu7: false,
    submenu8: false,
    submenu9: false,
    submenu10: false,
    submenu11: true,
    submenu12: false,
    submenu13: false,
  };
  isViewAll: boolean = false;
  isWrap = false; // Cấu hình cho xuống dòng
  isEvenly = false; // Cấu hình cho giãn đều
  currentViewAll: any = {};
  effect_hover = [];
  effect_hover_data: any = {};
  customize = [];
  stylefields = [
    {
      title: 'dieu_chinh_vien_danh_muc_cha',
      index: 1,
      isDrop: false,
    },
    {
      title: 'dieu_chinh_vien_danh_muc_con',
      index: 2,
      isDrop: false,
    },
    {
      title: 'dieu_chinh_vien_ket_qua',
      index: 3,
      isDrop: false,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
    {
      title: 'dieu_chinh_duong_vien_chung',
      index: 5,
    },
    {
      title: 'hieu_ung_cha',
      index: 6,
    },
    {
      title: 'hieu_ung_con',
      index: 7,
    },
  ];
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    public functionService: FunctionService,
    private vhEventMediator: VhEventMediator,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    if (!this.config.hasOwnProperty('type_show')) {
      this.config['type_show'] = 'DropdownSortComponent';
    }

    // Gán lại danh sách hiệu ứng để chọn
    this.setEffect();

    this.isWrap = this.class['sort-list']?.['flex-wrap'] == 'wrap';
    this.isEvenly = this.class['sort-list__item']?.['width'] == '100%' && this.class['+sort-list__item--inner']?.['flex'] == '1' && this.class['-sort-list__item--inner']?.['flex'] == '1';

    if (!this.config?.['is_radio']) this.config.is_radio = false;
    if (!this.config.hasOwnProperty('+sort_list_item_radio')) {
      this.config['+sort_list_item_radio'] = {
        "box-shadow": {
          "is_box_shadow": false,
          "property_box_shadow": {
            "type": "outset",
            "h-offset": 1,
            "v-offset": 1,
            "blur": 1,
            "spread": 1,
            "color": "#ffffffff"
          }
        }
      };
    }
    if (!this.config.hasOwnProperty('-sort_list_item_radio')) {
      this.config['-sort_list_item_radio'] = {
        "box-shadow": {
          "is_box_shadow": false,
          "property_box_shadow": {
            "type": "outset",
            "h-offset": 1,
            "v-offset": 1,
            "blur": 1,
            "spread": 1,
            "color": "#ffffffff"
          }
        }
      };
    }
    if (!this.class['sort-list__item']) this.class['sort-list__item'] = {};
    if (!this.config['animation-selected']?.id) {
      this.config['animation-selected'] ??= {};
      this.config['animation-selected']['id'] = '000000';
    }
    if (!this.class['+sort-list__item--radio']) this.class['+sort-list__item--radio'] = {}
    if (!this.class['-sort-list__item--radio']) this.class['-sort-list__item--radio'] = {}
  }

  ngOnChange() {
    if (this.effect_hover) {
      if ([6, 7].includes(this.currentViewAll.index)) {
        const effectSub = this.currentViewAll.index == 6 ? '' : '_sub';
        this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[`${this.device}_animation${effectSub}_type`])
        if (this.config[`animation${effectSub}-selected`]?.id && this.config[`animation${effectSub}-selected`].id !== '000000') {
          this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config[`animation${effectSub}-selected`].id)?.[`customize${effectSub}`] ?? [];
        }
      }
    }
  }

  /**
   * Gán danh sách hiệu ứng
   * @param typeShow
   */
  private setEffect(typeShow?: string) {
    let url = this.config['type_show'] == 'DropdownSortComponent'
      ? 'assets/data/effects/sort-product-drop-sort.json'
      : 'assets/data/effects/sort-product-horizontal-sort.json';

    if (typeShow) {
      url = typeShow == 'DropdownSortComponent'
        ? 'assets/data/effects/sort-product-drop-sort.json'
        : 'assets/data/effects/sort-product-horizontal-sort.json';
    }

    this.http.get(url).subscribe((effects: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type === this.staticdata[this.device + '_animation_type']
      );
    });
  }

  /**
   * Đặt flex-wrap cho sort-list
   * @description Thay đổi thuộc tính flex-wrap của sort-list khi click vào
   */
  handleSetWrap() {
    this.class['sort-list']['flex-wrap'] = (this.isWrap ? '' : 'no') + 'wrap';
    if (!this.isWrap) {
      this.class['sort-list']['justify-content'] = 'flex-start'
    }
    this.updateClass();
  }

  handleSetEvenly() {
    this.class['sort-list__item']['width'] = this.isEvenly ? '100%' : 'auto';
    this.class['+sort-list__item--inner']['flex'] = this.isEvenly ? '1' : 'none';
    this.class['-sort-list__item--inner']['flex'] = this.isEvenly ? '1' : 'none';
    this.updateClass();
  }
  
  handleSetAlign(property, value, className = 'sort-list') {
    this.class[className][property] = value;
    this.updateClass();
  }

  //Mở xem thêm
  openViewAll(field) {
    this.currentViewAll = field;
    this.isViewAll = !this.isViewAll;
  }

  openColor(): void {
    document.getElementById('color').click();
  }

  updateCss(name, value): void {
    this.dataAfterChange[name] = { ...value };
  }

  close(): void {
    this.saveDataProperties();
    this.closeConfigEvent.emit(null);
  }

  openBgColor(): void {
    document.getElementById('input-color').click();
  }

  // lấy giá trị từ radio input
  onChange(e): void {
    // if (this.device === 'desktop') {
    //   this.data_tool.desktop_direction_icon_button.flex_direction =
    //     e.target.value;
    //   this.updateCss(
    //     'desktop_direction_icon_button',
    //     this.data_tool.desktop_direction_icon_button
    //   );
    // } else {
    //   this.data_tool.mobile_direction_icon_button.flex_direction =
    //     e.target.value;
    // }
  }

  /** Hàm này thực hiện đóng/ mở menu
   * @param value: string
   */
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
      Object.keys(targetMap).forEach(key => {
        if (key !== value) targetMap[key] = false;
    });
  }

  /** Hàm này thực hiện lưu dữ liệu thuộc tính
   */
  saveDataProperties(): void {
    if (Object.keys(this.dataAfterChange).length)
      this.vhQueryAutoWeb
        .updateObject(this.objectChoosing._id, this.dataAfterChange)
        .then(
          (bool) => {},
          (error) => {
            console.error(error);
          }
        );
  }

  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
        // data: this.data
      })
      .then((bool: any) => {});
  }

  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {});
  }
  // */ Hàm update object vào database.
  // */
  updateObject() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
        [this.device + '_config']: this.config,
        staticdata: this.staticdata,
      })
      .then((bool: any) => {});
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {});
  }

  changeTypeShow(event) {
    // Gán lại danh sách hiệu ứng để chọn
    this.setEffect(event);

    if (event == 'HorizontalSortComponent') {
      this.class['product-category']['background-color'] = 'transparent';

      // Xử lý cho trường hợp chưa có animation, animation_type
      if (this.config['animation-selected']?.['id'] && this.config['animation-selected']['id'] != '000000') {
        if (!this.staticdata[this.device + '_animation_type'])
          this.staticdata[this.device + '_animation_type'] = 'none';
        if (!this.staticdata[this.device + '_animation_type'])
          this.staticdata[this.device + '_animation'] = {
            'animation-1': {
              '--1f-transform':
                'translateY(0) translateX(0) perspective(0px) rotate(0deg) rotateX(0deg) rotateY(0deg)',
              '--1t-transform':
                'translateY(0) translateX(0) perspective(0px) rotate(0deg) rotateX(0deg) rotateY(0deg)',
              '--1f-opacity': '0',
              '--1t-opacity': '1',
              '--1f-z-index': '-1',
              '--1t-z-index': '-1',
              '--1f-visibility': 'hidden',
              '--1t-visibility': 'visible',
              '--1-animation-duration-shared': '0.5s',
              '--1-animation-timing-function-shared': 'ease-in-out',
              '--1-animation':
                'sort-product-animate-1 var(--1-animation-duration-shared) var(--1-animation-timing-function-shared) 1',
              '--1-animation-direction': 'alternate',
              '--1-animation-fill-mode': 'forwards',

              '--1-transform': 'var(--1f-transform)',
              '--1-opacity': 'var(--1f-opacity)',
              '--1-visibility': 'var(--1f-visibility)',
              '--1-z-index': 'var(--1f-z-index)',
            },
          };
      }
    }
    else {
      this.class['product-category']['background-color'] = '#fff';
    }
    this.updateObject();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylefields[5]);
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetailChild(event) {
    this.customize = event;
    this.openViewAll(this.stylefields[6]);
  }

  /**
   *  Hàm này để xử lý hiệu ứng khi xuất hiện
   */
  openAnimationAppear() {
    this.customize = [
      {
        label: 'vi_tri_bat_dau',
        var: '--1f-transform',
        type: 'transform',
      },
      {
        label: 'vi_tri_ket_thuc',
        var: '--1t-transform',
        type: 'transform',
      },
      {
        label: 'do_trong_suot_bat_dau',
        var: '--1f-opacity',
        type: 'opacity',
      },
      {
        label: 'do_trong_suot_ket_thuc',
        var: '--1t-opacity',
        type: 'opacity',
      },
      {
        label: 'lop_bat_dau',
        var: '--1f-z-index',
        type: 'z-index',
      },
      {
        label: 'lop_ket_thuc',
        var: '--1t-z-index',
        type: 'z-index',
      },
      {
        label: 'thoi_gian_mot_chu_ky_hoat_canh_se_chay',
        var: '--1-animation-duration-shared',
        type: 'animation-duration',
      },
      {
        label: 'kieu_chay_hieu_ung',
        var: '--1-animation-timing-function-shared',
        type: 'animation-timing-function',
      },
    ];
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['product-category']['width'] = event.width + 'px';
    if (event.height) this.class['product-category']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }
}
